// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes growBox {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@keyframes slideBox {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@-webkit-keyframes rotating {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.loader.default {
  display: flex;
  color: #26bbf0;
}
.loader.default .icon {
  margin-left: 10px;
  margin-right: 10px;
}
.loader.full {
  min-height: calc(100vh);
  background-color: white;
  font-family: Roboto, Arial;
  color: #adafb6;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loader.full .msg {
  color: #6f787e;
  margin-top: 1rem;
  font-size: 1rem;
}
.loader.brainy {
  display: flex;
}
.loader.brainy .-icon svg {
  width: 40px;
  height: 40px;
  animation: rotating 2s linear infinite;
}
.loader.brainy .-icon svg path {
  fill: #9857ff;
}
.loader.brainy .-message {
  margin-top: 10px;
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/css/animations.less","webpack://./src/components/Loader.less"],"names":[],"mappings":"AACA;EACE;IACE,mBAAA;ECAF;EDEA;IACE,mBAAA;ECAF;AACF;ADIA;EACE;IAEE,QAAA;ECHF;EDKA;IACE,WAAA;ECHF;AACF;ADQA;EACE;IACE,+BAAA;ECNF;EDQA;IACE,iCAAA;ECNF;AACF;AAlBE;EACE,aAAA;EACA,cAAA;AAoBJ;AAtBE;EAKI,iBAAA;EACA,kBAAA;AAoBN;AAhBE;EACE,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAkBJ;AAhBI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAkBN;AAdE;EACE,aAAA;AAgBJ;AAjBE;EAIM,WAAA;EACA,YAAA;EACA,sCAAA;AAgBR;AAtBE;EAQQ,aAAA;AAiBV;AAzBE;EAaI,gBAAA;EACA,iBAAA;AAeN","sourcesContent":["// Grow an element from 0 to fullsize\n@keyframes growBox {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n// Grow an element from 0 width to full width\n@keyframes slideBox {\n  from {\n    //transform: scale(0);\n    width: 0;\n  }\n  to {\n    width: 100%;\n    //transform: scale(1);\n  }\n}\n\n// Rotate an element\n@-webkit-keyframes rotating {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n","// Loader CSS\n@import '@css/variables.less';\n@import '@css/animations.less';\n\n.loader {\n  &.default {\n    display: flex;\n    color: @loader-color;\n\n    .icon {\n      margin-left: 10px;\n      margin-right: 10px;\n    }\n  }\n\n  &.full {\n    min-height: calc(100vh);\n    background-color: white;\n    font-family: Roboto, Arial;\n    color: #adafb6;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\n    & .msg {\n      color: #6f787e;\n      margin-top: 1rem;\n      font-size: 1rem;\n    }\n  }\n\n  &.brainy {\n    display: flex;\n    .-icon {\n      svg {\n        width: 40px;\n        height: 40px;\n        animation: rotating 2s linear infinite;\n        path {\n          fill: @branding-primary-violet;\n        }\n      }\n    }\n    .-message {\n      margin-top: 10px;\n      margin-left: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
